import { isModKey } from '@repo/common/utils/keyboard';
import { isHash, isInternalUrl } from '@repo/common/utils/urls';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export function useEditorClickLink() {
	const navigate = useNavigate();

	return useCallback(
		(href: string, event: MouseEvent, forceNewTab: boolean = false) => {
			if (isModKey(event) || forceNewTab) {
				window.open(href, '_blank');
				return;
			}

			if (isHash(href)) {
				window.location.href = href;
				return;
			}

			if (isInternalUrl(href) && !href.includes('http')) {
				navigate(href);
			} else if (href) {
				window.location.href = href;
			}
		},
		[navigate]
	);
}
